import React, { FC, Fragment } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { TransportOrder, TransportStatus } from 'models/transport';
import { useTranslation } from 'react-i18next';
import TransportStatusIndicator from '../shared/transport-status-indicator.component';
import { NShiftShipmentWaybill } from 'models/nshift-shipment-waybill';

type TransportScheduleCellProps = {
    transportOrder?: TransportOrder;
    waybills?: NShiftShipmentWaybill[];
    onClick: () => void;
};
const TransportScheduleCell: FC<TransportScheduleCellProps> = ({
    transportOrder,
    waybills,
    onClick,
}: TransportScheduleCellProps) => {
    const { t: translate } = useTranslation(['transport']);

    const packageCount = () => {
        if (transportOrder) {
            return transportOrder.manualPackageCount + (transportOrder?.orders?.length || 0);
        }
        return 0;
    };

    const packageCountText = () => {
        if (transportOrder) {
            const packageCount = transportOrder.manualPackageCount + (transportOrder?.orders?.length || 0);
            return `${packageCount} ${translate('transport:PACKAGES')}`;
        }
        if (waybills && waybills.length > 0) {
            if (waybills.length === 1) {
                return `${waybills.length} ${translate('transport:WAYBILL')}`;
            }
            return `${waybills.length} ${translate('transport:WAYBILLS')}`;
        }
        return '';
    };

    return (
        <Fragment>
            <Box display="flex" alignItems="center">
                {transportOrder || waybills ? (
                    <Fragment>
                        <Box mr={1} mt="2px">
                            <TransportStatusIndicator
                                status={transportOrder?.status || TransportStatus.PRINTED}
                                hasProblem={transportOrder?.hasProblem || false}
                                showText={false}
                            />
                        </Box>
                        <Box>
                            <Button sx={{ marginBottom: '-5px' }} onClick={() => onClick()}>
                                <span>{packageCountText()}</span>
                                {transportOrder ? (
                                    <span>
                                        {transportOrder?.deadline && transportOrder?.deadline !== 'No Deadline'
                                            ? `, ${transportOrder?.deadline}`
                                            : undefined}
                                    </span>
                                ) : undefined}
                                {transportOrder?.isSameDayDelivery ? (
                                    <Box ml={1} display="inline-flex" alignItems="center">
                                        <Typography
                                            sx={{ fontSize: '0.7rem' }}
                                            variant="subtitle2"
                                            color="warning.main"
                                        >
                                            {translate(`transport:SAME_DAY_DELIVERY`)}
                                        </Typography>
                                    </Box>
                                ) : undefined}
                            </Button>
                            {transportOrder ? (
                                transportOrder?.actualPackageCount &&
                                packageCount() !== transportOrder?.actualPackageCount ? (
                                    <Box ml={1} color="warning.main">
                                        {transportOrder?.actualPackageCount}{' '}
                                        {translate('transport:PACKAGES_TRANSPORTED')}
                                    </Box>
                                ) : undefined
                            ) : undefined}
                        </Box>
                    </Fragment>
                ) : undefined}
            </Box>
        </Fragment>
    );
};

export default TransportScheduleCell;
